export default __webpack_public_path__ + "static/media/ticket_purchase_sp.015bfbf5.jpg";